import { Divider } from '@cube3/cubicle/src/core/atoms/Divider/Divider';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import { VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import React, { useMemo } from 'react';
import { Field, FieldWithState } from '../types/GenericFormTypes';

interface Props {
  fields: Array<Field | FieldWithState>;
  gap: number;
  renderField: (field) => JSX.Element;
}

export const GroupFields = ({ fields, gap, renderField }: Props) => {
  /** Split fields by their `groupLabel` */
  const fieldsUI = useMemo(() => {
    return fields.reduce((acc, f) => {
      const title = f.groupBy || f.groupLabel || 'undefined';
      if (!acc[title]) {
        acc[title] = [];
      }
      acc[title].push(f);
      return acc;
    }, {});
  }, [fields]);

  if (!fields) return null;

  return (
    <>
      {Object.keys(fieldsUI).map((groupBy, idx) => {
        const grouped = groupBy !== 'undefined';
        const items = fieldsUI[groupBy];
        if (grouped) {
          const groupLabel = items[0].groupLabel;
          const column = items[0].column || 1;
          return (
            <section key={groupBy + idx} style={{ marginBottom: gap }}>
              <VBox gap={gap}>
                {groupLabel && (
                  <Typography variant="lg" weight="label" colorVariant="03">
                    {groupLabel}
                  </Typography>
                )}

                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${column}, 1fr)`,
                    gap: gap
                  }}
                >
                  {items.map((field) => renderField(field))}
                </div>
                {/* add divider between groups */}
                {groupLabel && idx < Object.keys(fieldsUI).length - 1 ? (
                  <span style={{ marginBottom: gap }}>
                    <Divider />
                  </span>
                ) : null}
              </VBox>
            </section>
          );
        }
        return (
          <VBox gap={gap} key="ungrouped_redux-fields">
            {items.map((field) => renderField(field))}
          </VBox>
        );
      })}
    </>
  );
};
